import {
  GET_USER_WALLETS_START,
  GET_USER_WALLETS_SUCCESS,
  GET_USER_WALLETS_ERROR,
} from 'constants/action-types/user/getUserWallets';
import apiAction from 'helpers/apiAction';

export default userId => dispatch => {
  dispatch(
    apiAction({
      url: '/user/wallets',
      queries: { user_id: userId },
      method: 'GET',
      API_REQUEST_START: GET_USER_WALLETS_START,
      API_REQUEST_SUCCESS: GET_USER_WALLETS_SUCCESS,
      API_REQUEST_FAILURE: GET_USER_WALLETS_ERROR,
      onSuccess: ({ data }) => {
        dispatch({
          type: GET_USER_WALLETS_SUCCESS,
          payload: data,
        });
      },
      onEnd: () => false,
    }),
  );
};
